import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const invitationApi = {
  list (params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/invitations/`, {params: params}
    )
  },
  detail (invitationId, params) {
    // 详情
    return axios.get(
      `${ApiSetting.baseUrl}/api/invitations/${invitationId}/`,
      {params: params}
    )
  },
  create (params) {
    return axios.post(
      `${ApiSetting.baseUrl}/api/invitations/`, querystring.stringify(params)
    )
  },
  update (invitationId, params) {
    return axios.put(
      `${ApiSetting.baseUrl}/api/invitations/${invitationId}/`,
      querystring.stringify(params)
    )
  }
}

export default invitationApi
